import React, { useState } from "react";
import {
  Box,
  Typography,
  Card,
  Button,
  IconButton,
  Collapse,
  Stack,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import DaalchiniLogo from "../assets/DaalchiniLogo.png";
import { IMAGE_BASE_URL } from "../config";
import Purchased from "../assets/Purchased.png";
import time from "../assets/ValidUntil.png";
import terms from "../assets/term.png";
import  copy from "../assets/copy.png";
import Cliam from "../assets/helpClaimBg.gif";
import { useNavigate } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import YouWon from "../assets/YouWon.gif";
import AddEmail from "../Components/A_Redeem/AddEmail";
import SuccessClaim from "./Success";
import ClaimUnsuccessful from "./UnSucess";
export default function DGC({ digitalorderDetailsData,profileData }) {
  const [openTerms, setOpenTerms] = useState(false);
const [showCode, setShowCode] = useState(false);
const [openAddEmail,setOpenAddEmail]=useState(false)
const param=new URLSearchParams(window.location.search);    
const orderId=param.get("orderId");
const code = digitalorderDetailsData?.code || "ABCD1234";
const navigate=useNavigate();
const onClose=()=>{
    setOpenAddEmail(false)
}
const handleGetCode = () => {
  setShowCode(true);

};

const handleCopyCode = () => {
  navigator.clipboard.writeText(code);
  alert("Code copied to clipboard!");
}

const validityDays = digitalorderDetailsData?.validityDays || 0;

const currentDate = new Date();
const expiryDate = new Date(currentDate);

expiryDate.setDate(currentDate.getDate() + validityDays);

const formattedDate = expiryDate.toLocaleDateString("en-US", {
  month: "short",
  day: "2-digit",
  year: "numeric",
});
const gotoHome=()=>{
    navigate('/')
}

const handleClaim = (orderId) => {
  
navigate(`/tagOrderId?value=${orderId}`); // internal route

};


const Header = ({ onBackClick }) => (
  <Stack
    direction="row"
    alignItems="center"
    sx={{ mb: 3, position: "relative" }}
  >
    {/* 🔥 Circular Back Button */}
    <Box
      onClick={onBackClick}
      sx={{
        position: "absolute",
        left: 0,
        width: 36,
        height: 36,
        borderRadius: "50%",
        border: "2px solid #555",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      }}
    >
      <ArrowBackIosNewIcon
        sx={{
          fontSize: 16,
          color: "#555",
          //ml: "2px", // slight adjust for visual center
        }}
      />
    </Box>

    {/* Logo */}
    <Box
      sx={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <img src={DaalchiniLogo} style={{ width: "100px" }} alt="logo" />
    </Box>
  </Stack>
);

const gotoback=()=>{
    navigate(-1);
}
  return (
    <Box
    style={{background:"radial-gradient(circle, rgba(245, 233, 233, 0.408) 0%, rgba(185, 245, 247, 0.34) 100%)"}}
      sx={{
        minHeight: "100vh",
        //bgcolor: "#f3f4f6",
        display: "flex",
        justifyContent: "center",
        alignItems: { xs: "flex-start", md: "center" },
        
     
      }}
    >
        <AddEmail open={openAddEmail} onClose={onClose}/>
      {/* Main Container */}
 <Box
  sx={{
    width: "100%",
    maxWidth: { xs: "100%", sm: 420, md: 450 },

   

    borderRadius: { md: 3 },
    boxShadow: { md: "0px 10px 30px rgba(0,0,0,0.08)" },
    p: { xs: 2, sm: 3 },
  }}
>


     <Header onBackClick={gotoback} />

{ digitalorderDetailsData?.claimStatus=="CLAIMED"&&<SuccessClaim IMAGE_BASE_URL={IMAGE_BASE_URL} digitalorderDetailsData={digitalorderDetailsData}/>
}{(digitalorderDetailsData?.claimStatus=="FAILED")&&<ClaimUnsuccessful IMAGE_BASE_URL={IMAGE_BASE_URL} digitalorderDetailsData={digitalorderDetailsData}/>
}        {/* Code Box */}
    {digitalorderDetailsData.fulfilmentType=="DGC"&&<Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    bgcolor: "#fff",
    borderRadius: 2,
    px: 2,
    py: 1.5,
    border: "1px solid #e5e7eb",
    mb: 3,
  }}
>
  {/* Code */}
  <Typography letterSpacing={3} fontWeight={400} style={{    textTransform: "uppercase"}}>
    {showCode ? code : "••••••••"}
  </Typography>

  {/* Get Code */}
  <Typography
    color="#00A86B"
    fontWeight={600}
    sx={{ cursor: "pointer" }}
    onClick={handleGetCode}
  >
    {showCode ? <img src={copy} alt="Copy"  width={30}   onClick={(e) => { e.stopPropagation(); handleCopyCode(); }}/> : "Get Code"}
  </Typography>
</Box>}
    {digitalorderDetailsData.fulfilmentType=="VOUCHER"&&<Box
  sx={{
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    bgcolor: "#fff",
    borderRadius: 2,
    px: 2,
    py: 1.5,
    border: "1px solid #e5e7eb",
    mb: 3,
  }}
>
  {/* Code */}
<Typography
style={{    textTransform: "uppercase"}}
  letterSpacing={3}
  fontWeight={400}
  fontFamily={"Roboto"}
  
>
  {showCode ? code : "••••••••"}
</Typography>

  {/* Get Code */}
  <Typography
    color="#00A86B"
    fontWeight={600}
    sx={{ cursor: "pointer" }}
    onClick={handleGetCode}
  >
    {showCode ? <img src={copy} alt="Copy"  width={30}   onClick={(e) => { e.stopPropagation(); handleCopyCode(); }}/> : "Get Code"}
  </Typography>
</Box>}

        {/* Plan Details */}
        <Card
          sx={{
            p: 2,
            borderRadius: 3,
            boxShadow: "0px 2px 12px rgba(0,0,0,0.06)",
            mb: 3,
          }}
        >
          <Typography variant="body2" color="text.secondary" mb={1}>
            Plan Details
          </Typography>

          <Typography fontWeight={600}>
           {digitalorderDetailsData?.variantName}
          </Typography>
          <Typography variant="body2" color="text.secondary" mb={2}>
           {digitalorderDetailsData?.variantDescription}
          </Typography>

          {/* Purchased */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
            <img src={Purchased} width={20} alt="" />
            <Box ml={1}>
              <Typography variant="caption" color="text.secondary">
                Purchased With
              </Typography>
              <Typography variant="body2">
                {console.log("profileData",profileData)}
                {digitalorderDetailsData?.email? digitalorderDetailsData.email : profileData?.mobileNo? profileData.mobileNo : "N/A"}
              </Typography>
            </Box>
          </Box>

          {/* Valid */}
          <Box sx={{ display: "flex", alignItems: "center", mb: 1.5 }}>
            <img src={time} width={20} alt="" />
            <Box ml={1}>
              <Typography variant="caption" color="text.secondary">
                Valid Until
              </Typography>
              <Typography variant="body2">
               {formattedDate}
              </Typography>
            </Box>
          </Box>

          {/* Terms Section */}
          <Box sx={{ mt: 1 }}>
            <Box
              onClick={() => setOpenTerms(!openTerms)}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                cursor: "pointer",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <img src={terms} width={20} alt="" />
                <Typography ml={1} variant="body2">
                  Terms & Condition
                </Typography>
              </Box>

              <ExpandMoreIcon
                sx={{
                  transition: "0.3s",
                  transform: openTerms ? "rotate(180deg)" : "rotate(0deg)",
                }}
              />
            </Box>

            {/* Expand Content */}
            <Collapse in={openTerms}>
              <Box sx={{ mt: 1 }}>
                <Typography variant="caption" color="text.secondary">
                {digitalorderDetailsData.tnc}
                </Typography>
                <br />
         
              </Box>
            </Collapse>
          </Box>
        </Card>

 

                       {!(digitalorderDetailsData?.claimStatus=="FAILED")&& <Box
                    mt={1}
                    mb={2}
                    sx={{
                      position: "relative",
                      borderRadius: 3,
                      overflow: "hidden",
                      p: { xs: 3, md: 4 },
                      
                      
                      textAlign: "center",
                      backgroundImage: `url(${Cliam})`,
                      backgroundSize: "cover",
                     
        
                    }}
                    display={"flex"}
                    justifyContent={"center"}
                    style={{paddingLeft:"0px",paddingBottom:"0px", background: "linear-gradient(to bottom, #A1C6B8 0%, #EEF6F3 100%)",}}
                  >
                    <img src={YouWon} style={{width:"100px",position:"relative",zIndex:"999"}}/>
                    <Box
                      sx={{
                        position: "absolute",
                        inset: 0,
                        bgcolor: "rgba(238,247,244,0.88)",
                          backgroundImage: `url(${Cliam})`,
                            backgroundSize: "cover",
                      }}
                    />
        
                    <Box sx={{ position: "relative" }}>
                      <Typography fontWeight={800} fontSize={16} textAlign={"start"}>
                        Reward Unlocked!
                      </Typography>
        
                      <Typography variant="body2" mb={0} fontSize={12}>
                        You've Won Cashback On This Order
                      </Typography>
        <div style={{    display: "flex",
            justifyContent: "flex-start"}}>
                    <Button
          variant="contained"
          onClick={()=>{handleClaim(orderId)}}
          style={{position:"absolute",zIndex:999}}
          
          endIcon={
            <Box
              sx={{
                bgcolor: "#fff",
                color: "#00a676",
                borderRadius: "50%",
                width: 22,
                height: 22,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <ArrowForwardIcon fontSize="small" />
            </Box>
          }
          sx={{
            bgcolor: "#00a676",
            borderRadius: 8,
            px: 4,
            fontWeight: 700,
            pl:"8px",
            pr:"8px",
            height:"28px",
            mt:"5px",
        
            // ✅ ADD THIS
            "& .MuiButton-endIcon": {
              marginLeft: "16px", // increase gap here
            },
        
            "&:hover": { bgcolor: "#008f63" },
          }}
        >
          Claim Now
        </Button>
        
        </div>
        <img src={Cliam} style={{position:"absolute",top:"-14px",right:"-54px"}}/>
        
                    </Box>
                  </Box>}

        {/* Buttons */}
<Button
  fullWidth
  variant="contained"
  sx={{
    bgcolor: "#00A86B",
    borderRadius: 2,
    py: 1.5,
    textTransform: "none",
    mb: 1.5,
    "&:hover": { bgcolor: "#008f5a" },
  }}
  onClick={() => {
    if(digitalorderDetailsData?.claimStatus=="FAILED"){
      gotoHome();
      return;
    }       
    if (digitalorderDetailsData.fulfilmentType === "DGC") {
      navigate(`/giftCard?code=${digitalorderDetailsData.code}`);
    } else {
      window.location.href = digitalorderDetailsData?.redemptionUrl // ✅ fixed
    }
  }}
>
{ digitalorderDetailsData?.claimStatus=="FAILED"?<>{ "Go To Home"}</>:digitalorderDetailsData?.ctaText  }
</Button>

        <Button
          fullWidth
          variant="outlined"
          sx={{
            borderRadius: 2,
            py: 1.5,
            textTransform: "none",
            color: "#555",
            borderColor: "#ddd",
            backgroundColor: "white",
          }}
          //onClick={()=>gotoHome()}
          onClick={()=>{
                if(digitalorderDetailsData?.claimStatus=="FAILED"){
      navigate(`/orders`);
      return;
    } 
    else{
        navigate(`/`);
    }
            
            //setOpenAddEmail(true)
            }
            }
          
        >
         { digitalorderDetailsData?.claimStatus=="FAILED"?"View Orders":"Home"}
        </Button>
      </Box>
    </Box>
  );
}